import PropTypes from 'prop-types';

export const AddressModelShape = PropTypes.shape({
  Country: PropTypes.string,
  StateOrProvince: PropTypes.string,
  City: PropTypes.string,
  PostalCode: PropTypes.string,
  Line1: PropTypes.string,
  Line2: PropTypes.string,
  Line3: PropTypes.string,
  Line4: PropTypes.string,
});

export const PassiveErrorShape = PropTypes.shape({
  showErrorOnPassiveMessages: PropTypes.bool,
  passiveMessages: PropTypes.arrayOf(PropTypes.string),
});
